import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setAlert, setAvailablePages } from 'redux/app/appSlice';

import appService from 'services/appService';

const getAlert = () => async dispatch => {
  try {
    const response = await appService.getAlert()

    dispatch(setAlert(response.data.alert))
  } catch (e) {
    if (e.response?.status === 401) return
    Notify.failure(e.response?.data?.message || 'Request GetAlert failure')
  }
}

const setLanguage = async (language) => {
  try {
    await appService.setLanguage(language)
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request SetLanguage failure')
  }
}

const getAvailablePages = () => async dispatch => {
  try {
    const response = await appService.getAvailablePages()
    const { partner = true, monitoring = true } = response.data

    dispatch(setAvailablePages({ partner, monitoring }))
  } catch (e) {
    if (e.response?.status === 401) return
    Notify.failure(e.response?.data?.message || 'Request GetAvailablePages failure')
  }
}

export default {
  getAlert,
  setLanguage,
  getAvailablePages,
}
